import { memo, type FC } from "react";

import { IconType } from "../../../../common/components/icon/IconType";
import { LinkButton } from "../../../../common/components/Link";
import { Icon } from "../../../../common/components/icon/Icon";
import { useDispatch } from "react-redux";
import { clearCart } from "../../../redux/actions/cartPageActions";
import DeleteCartConfirmationModal from "../../../../common/components/DeleteCartConfirmationModal";
import { useTranslation } from "react-i18next";
import { openModal } from "~/AddToCart/ModalSevice";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

interface ClearCartButtonProps {
  className?: string;
  isB2BCart?: boolean;
}

export const useClearCartAction = () => {
  const dispatch = useDispatch();

  return () => {
    openModal("deleteCartConfirmation", (close) => (
      <DeleteCartConfirmationModal
        onOk={() => {
          close();
          dispatch(clearCart());
        }}
        onCancel={close}
      />
    ));
  };
};

const ClearCartButton: FC<ClearCartButtonProps> = ({ className, isB2BCart = false }) => {
  const { t } = useTranslation();

  const clickHandler = useClearCartAction();

  return (
    <LinkButton
      onClick={clickHandler}
      data-test-id={"btn-clear-cart"}
      className={className}
      iconBefore={isB2BCart ? <DeleteOutlineOutlinedIcon /> : <Icon type={IconType.Bin} />}
    >
      {t(isB2BCart ? "page.cart.action.clearCart" : "page.cart.button.clearCart")}
    </LinkButton>
  );
};

export default memo(ClearCartButton);
